import { render, staticRenderFns } from "./StateTabs.vue?vue&type=template&id=090c2aba"
import script from "./StateTabs.vue?vue&type=script&lang=js"
export * from "./StateTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports